export const formatDateUsa = (date) => {
    if (!date) return "";
    const [day, month, year] = date.split("/");
    return `${year}-${month}-${day}`;
};

export const formatDatePtBr = (date) => {
    if (!date) return "";
    const finalDate = date.split("T")?.[0];
    const [year, month, day] = finalDate.split("-");
    return `${day}/${month}/${year}`;
};